var agp = agp || {};

agp.disclaimer = (function () {

	function init() {
		var defaultName = 'auto-cookie',
			defaultInstance = 0;

		$('.js--disclaimer').each(function () {
			var $disclaimer = $(this),
				name = $(this).data('cookie-name') || (function () {
					defaultInstance++;
					return defaultName + defaultInstance;
				}()),
				// eslint-disable-next-line no-undef
				cookie = getCookie(name),
				close = function () {
					//$disclaimer.removeClass('disclaimer--show');
					$("[data-cookie-name='" + name + "']").removeClass('disclaimer--show');
				};

			// eslint-disable-next-line no-undef
			setCookie(name, 'true', 365);

			//App.Debug.trace('setCookieFunc() - Tracing cookie for', this, name, cookie);

			$disclaimer.find('.disclaimer__close').on('click', function (event) {
				event.preventDefault();
				close();
			});

			if (cookie === 'true') {
				return;
			} else {
				$("[data-cookie-name='" + name + "']").addClass('disclaimer--show');
			}

		});
	}

	return {
		init: init
	};

}());